<auth-template>
	<email-verification
		*ngIf="!emailSignature && !resetLinkExpired"
		[mode]="verificationModes.PASSWORD_RESET"
		[email]="email"
		(onResend)="navigateToForgotPage()"
		(onComplete)="verifyEmail($event)">
	</email-verification>
	<div *ngIf="emailSignature || resetLinkExpired" class="reset-wrap">
		<div class="reset-content">
			<section>
				<form [formGroup]="form" #content (ngSubmit)="submit()"
					class="reset-form"
					*ngIf="!resetSuccess && !resetFailed && !resetLinkExpired">
					<div class="header" translate="reset-password_title"></div>

					<mat-form-field appearance="outline" class="new-password" goPasswordVisibilityToggle goPasswordRequirements>
						<mat-label translate="reset-password_new_password_label"></mat-label>
						<input type="password" matInput formControlName="password" class="fullstory-ignore new-password-input" />
						<button
							mat-icon-button
							matIconSuffix
							[matTooltip]="'sign-up-password-rules' | translate">
							<mat-icon
								class="ficon-app-help-circle-outline">
							</mat-icon>
						</button>
						<mat-error *ngIf="form.controls.password.invalid" translate="common_password_error-password-requirements"></mat-error>
					</mat-form-field>

					<button type="submit" [disabled]="loading" class="submit-btn primary-btn" translate="reset-password_title" [focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}"></button>
				</form>

				<div class="reset-success" *ngIf="resetSuccess">
					<div class="header" translate="reset-password_title"></div>
					<p class="message" translate="reset-password_success-message"></p>
					<button (click)="navigateToLogin()" queryParamsHandling="preserve" class="primary-btn" translate="reset-password_success-continue_btn_text"></button>
				</div>

				<div class="reset-failed" *ngIf="resetFailed">
					<div class="header" translate="reset-password_title"></div>
					<p class="message" translate="reset-password_failed-message"></p>
					<button (click)="navigateToForgotPage()" queryParamsHandling="preserve" class="primary-btn" translate="reset-password_success-continue_btn_text"></button>
				</div>

				<div class="reset-link-expired" *ngIf="resetLinkExpired">
					<div class="header" translate="reset_password-link-expired_title"></div>
					<p class="message" translate="reset-password-link-expired_message"></p>
					<button (click)="navigateToForgotPage()" queryParamsHandling="preserve" class="primary-btn" translate="reset-password_success-continue_btn_text"></button>
				</div>
			</section>
		</div>
	</div>
</auth-template>
